import { render } from "./PayReceiveBoard.vue?vue&type=template&id=72bc4e0c&scoped=true"
import script from "./PayReceiveBoard.vue?vue&type=script&lang=js"
export * from "./PayReceiveBoard.vue?vue&type=script&lang=js"

import "./PayReceiveBoard.vue?vue&type=style&index=0&id=72bc4e0c&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bc4e0c"]])

export default __exports__